import { FeedbackApi } from 'api';
import { useAuthMutation } from 'queries/query';

function useCreate() {
  return useAuthMutation(FeedbackApi.post);
}

export default useCreate;
